import React from "react";
import { SimpleToast } from "@coworker/apprestructured/src/shared/simple/SimpleToast/SimpleToast";

interface ScannerPageProps {
  error: string;
  onClose: () => void;
}

const ScannerErrorComponentPresentation: React.FC<ScannerPageProps> = ({
  error,
  onClose,
}) => {
  return (
    <SimpleToast
      text={error}
      isOpen={true}
      onCloseRequest={onClose}
      ariaLabel={`Error notification: ${error}`}
    />
  );
};

export default ScannerErrorComponentPresentation;
